<!-- See https://travishorn.com/form-validation-with-vue-js-4d2e7ba8d2fc, bootstrap vue documentation is poor -->
<template>
    <b-container fluid class='top-padding'>

        <h2 v-if='inSubscribeFlow'>Please Sign In or Create an Account to Subscribe</h2>
        <hr v-if='inSubscribeFlow' />

        <h2>Sign In To Existing Account</h2>

        <b-form :novalidate='true' @submit="onSubmit">
            <b-form-group id="emailInputGroup" :class="{ 'is-invalid': formSubmitAttempted && !isValidEmail()}">
                <b-form-input id="emailInput" type="email" v-model="form.email" required autofocus placeholder="Enter email" :class="{ 'is-invalid': formSubmitAttempted && !isValidEmail()}">
                </b-form-input>
                <b-form-invalid-feedback id="emailInputFeedback">
                    Enter a valid email address containing an @ symbol
                </b-form-invalid-feedback>
                <!-- <b-form-text id="emailInputHelp">Your Handweaving.net account email address</b-form-text> -->
            </b-form-group>
            <b-form-group id="passwordInputGroup">
                <b-form-input id="passwordInput" type="password" v-model="form.password" required placeholder="Enter password" :class="{ 'is-invalid': formSubmitAttempted && !isValidPassword()}">
                </b-form-input>
                <!-- <b-form-text id="emailInputHelp">Your Handweaving.net account password</b-form-text> -->
                <b-form-invalid-feedback id="emailInputFeedback">
                    Enter your account password
                </b-form-invalid-feedback>
            </b-form-group>
            <b-button type="submit" variant="primary" title='Sign in'>Sign In</b-button>
        </b-form>

        <div v-if='loginFailed'>
            <div class='top-padding bottom-padding'>
                <span class='text-danger'>Sign in failed: </span>
                <span class='text-danger'>{{loginFailedReason}}</span>
                <br v-if='hint' /><br v-if='hint' />
                <span v-if='hint'>Hint: {{hint}}</span>
            </div>
        </div>

        <div v-if='(showForgotPassword)'>
            <div class='top-padding bottom-padding'>
                <b-button variant='primary' @click='showResetPasswordConfirmModal'>
                    Reset Password
                </b-button>
            </div>
        </div>

        <div v-if='loginFailed' class='top-padding bottom-padding'>
            If you have an account but cannot remember which email address you used to register, please
            <router-link to='Contact'>contact us</router-link> for assistance!
        </div>

        <hr/>

        <div>
            <h2>Need an Account?</h2>

            <div class='bottom-padding'>
                Basic accounts are free and enable personalized features such as draft clipboards, downloads, and contributing your own drafts.
            </div>

            <b-button variant='primary' title='Create a new account' @click='goCreateAccount'>Create New Account Now</b-button>
        </div>
        
        <b-modal auto-focus-button='ok' ref='inSubscribeFlowModalRef' title='Sign In Successful' ok-title='Continue »' @ok='handleModalOk' ok-only :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                {{ authUser.Name }} Welcome to Handweaving.net!
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='activeSingleModalRef' :title='"Welcome, " + authUser.Name + "!"' ok-only @ok='handleModalOk' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Your subscription lasts until {{ subscriptionExpirationDateWithFullMonth }}.  Thanks for your support!
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='activeRenewsModalRef' :title='"Welcome, " + authUser.Name + "!"' ok-only @ok='handleModalOk' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Your {{authUser.SubscriptionType}} subscription renews on {{ subscriptionExpirationDateWithFullMonth }}.  Thanks for your support!
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='expiredModalRef' :title='"Welcome, " + authUser.Name + "!"' ok-title='Renew Subscription »' @ok='handleModalOk' cancel-title='Not Now' @cancel='handleModalCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Your subscription has expired, please resubscribe to get more!
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='cancelledModalRef' :title='"Welcome, " + authUser.Name + "!"' ok-title='Resubscribe »' @ok='handleModalOk' cancel-title='Not Now' @cancel='handleModalCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Your {{authUser.SubscriptionType}} subscription has been cancelled but may still be used until {{ authUser.SubscriptionExpirationDateWithFullMonth }}.  Please resubscribe to get more!
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='noneModalRef' :title='"Welcome, " + authUser.Name + "!"' ok-title='Continue »' @ok='handleModalOk' cancel-title='Not Now' @cancel='handleModalCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Subscribe now to get access to full drafts and many more features!
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='confirmResetPasswordModalRef' title='Recover Password' ok-title='Recover Password »' @ok='handleResetPasswordConfirmed' cancel-title='Not Now' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Do you want to recover your password now? A new one will be emailed to you.
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='completedResetPasswordModalRef' title='Password Reset Completed' ok-only :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                A new temporary password has been sent to {{ this.resetPasswordEmailAddress }}.  Please log in with this email and password, then use the Account link in the menu to reset the password.
            </div>
        </b-modal>
                                                
    </b-container>
</template>

<script>
import dataService from '../mixins/dataService.js'
import utilityService from '../mixins/utilityService.js'

export default {
    mixins: [dataService, utilityService],
    data() {
        return {
            // this is the data model for the form
            form: {
                email: '',
                password: ''
            },
            formSubmitAttempted: false,
            loginFailed: false,
            showForgotPassword: false,
            loginFailedReason: '',
            hint: null,
            resetPasswordEmailAddress: ''
        }
    },
    methods: {

        onSubmit(evt) {
            evt.preventDefault()
            this.formSubmitAttempted = true
            if (!this.entireFormValid()) {
                return false
            }
            this.postLogin(this.form.email, this.form.password).then(resp => {
                let user = resp.data
                this.loginFailed = false
                this.showForgotPassword = false

                if (resp.success) {
                    // either login was successful or user was found but password didn't match
                    if (!this.guidIsEmpty(user.LoginToken)) {
                        // successful if login token returned
                        this.loginFailed = false

                        // success, persist the user and show message/dialog
                        this.$store.commit('setAuthUser', user)
                        window.localStorage.setItem('user', JSON.stringify(user))

                        this.getUserSettings(user.UserID, user.LoginToken).then(resp => {
                            // console.log('Logged in user, loading settings, userID: ' + user.UserID + ', settings: ' + JSON.stringify(resp.data))
                            this.$store.commit('setAuthUserSettings', resp.data)
                        })

                        this.showModal()
                    }
                    else {
                        // user was found but password didn't match, the only new value returned in this case is Hint if it exists
                        this.loginFailed = true
                        this.hint = user.Hint
                        this.loginFailedReason = 'password is incorrect.'
                        this.showForgotPassword = true
                        this.resetPasswordEmailAddress = this.form.email  // capture this so reset works even if the user changes the email in the textbox
                    }
                }
                else if (resp.status >= 400 && resp.status < 500) {
                    this.loginFailed = true
                    this.loginFailedReason = 'no account exists for this email address.'
                }
                else {
                    this.loginFailed = true
                    this.loginFailedReason = 'Internet connection problem, please try again once this improves.'
                }
            })
        },

        goCreateAccount: function() {
            this.$router.replace({ name: 'Account' })
        },

        isValidEmail: function() {
            return this.isValidEmailAddress(this.form.email)
        },

        isValidPassword: function() {
            let password = this.form.password.trim()
            if (password === null) {
                return false
            }
            if (password.length < 2) { // note: don't call utility.validPasswordFormat here because some older passwords could still be in effect which don't comply with that, this is checking only to make sure something got input
                return false
            }
            return true
        },

        entireFormValid: function() {
            return this.isValidEmail() && this.isValidPassword()
        },

        showHideModal: function(isShow) {
            let currentRoute = this.$router.currentRoute.name
            if (currentRoute === 'Subscription') {
                isShow ? this.$refs.inSubscribeFlowModalRef.show() : this.$refs.inSubscribeFlowModalRef.hide()
            }
            else {
                if (this.authUser.SubscriptionStatus === 'activeSingle') {
                    isShow ? this.$refs.activeSingleModalRef.show() : this.$refs.activeSingleModalRef.hide()
                }
                else if (this.authUser.SubscriptionStatus === 'activeRenews') {
                    isShow ? this.$refs.activeRenewsModalRef.show() : this.$refs.activeRenewsModalRef.hide()
                }
                else if (this.authUser.SubscriptionStatus === 'expired') {
                    isShow ? this.$refs.expiredModalRef.show() : this.$refs.expiredModalRef.hide()
                }
                else if (this.authUser.SubscriptionStatus === 'cancelled') {
                    isShow ? this.$refs.cancelledModalRef.show() : this.$refs.cancelledModalRef.hide()
                }
                else if (this.authUser.SubscriptionStatus === 'none') {
                    isShow ? this.$refs.noneModalRef.show() : this.$refs.noneModalRef.hide()
                }
            }
        },

        showModal: function() {
            this.showHideModal(true)
        },

        hideModal: function() {
            this.showHideModal(false)
        },

        showResetPasswordConfirmModal: function() {
            this.$refs.confirmResetPasswordModalRef.show()
        },

        hideResetPasswordConfirmModal: function() {
            this.$refs.confirmResetPasswordModalRef.hide()
        },

        showResetPasswordResetCompletedModal: function() {
            this.$refs.completedResetPasswordModalRef.show()
        },

        handleModalOk: function() {
            this.hideModal()

            if (this.authUser.SubscriptionStatus === 'expired') {
                this.$router.push({ name: 'Subscription' })
            }
            else if (this.authUser.SubscriptionStatus === 'cancelled') {
                this.$router.push({ name: 'Subscription' })
            }
            else if (this.authUser.SubscriptionStatus === 'none') {
                this.$router.push({ name: 'Subscription' })
            }
            else {
                this.navigateBackToPreviousPage()
            }
        },

        handleModalCancel: function() {
            this.hideModal()
            this.navigateBackToPreviousPage()
        },

        handleResetPasswordConfirmed: function() {
            this.hideResetPasswordConfirmModal()
            this.sendForgotPasswordEmail(this.resetPasswordEmailAddress).then((resp) => {
                this.showResetPasswordResetCompletedModal()
            })
        },

        handleResetPasswordConfirmedCancel: function() {
            this.hideResetPasswordConfirmModal()
        },

        navigateBackToPreviousPage() {
            this.$router.go(-1)
        }

    },
    computed: {
        subscriptionExpirationDate: function() {
            return this.$store.state.authUser.SubscriptionExpirationDate
        },
        subscriptionExpirationDateWithFullMonth: function() {
            return this.$store.state.authUser.SubscriptionExpirationDateStrWithMonth
        },
        authUser: function() {
            return this.$store.state.authUser
        },
        subscriptionStatus: function() {
            return this.$store.state.authUser.SubscriptionStatus
        },
        inSubscribeFlow: function() {
            let prevRoute = this.$store.state.previousRouteName
            return prevRoute === 'Subscription'
        }
    },
    created() {
        this.scrollToTop()
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue